import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, KeyRound } from "lucide-react";
import api from "../lib/api";
import { Logo } from "../components/common";
import { formatError } from "../context/AuthContext";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Invalid reset link.");
    if (pw.length < 6) return toast.error("Password must be at least 6 characters.");
    if (pw !== confirm) return toast.error("Passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Password updated!");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Could not reset password.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <Link to="/"><Logo /></Link>
        {done ? (
          <div className="card-surface rounded-2xl p-8 mt-8 text-center">
            <CheckCircle2 className="w-14 h-14 text-success mx-auto" />
            <h1 className="font-heading text-4xl mt-4">All set!</h1>
            <p className="text-secondary mt-1">Your password has been updated.</p>
            <button data-testid="reset-login" onClick={() => navigate("/login")} className="w-full mt-6 py-3 bg-brand text-white font-bold uppercase tracking-wide rounded-lg hover:bg-brand-hover transition-all">Go to Login</button>
          </div>
        ) : (
          <>
            <div className="bg-brand/15 w-12 h-12 rounded-lg flex items-center justify-center mt-8"><KeyRound className="w-6 h-6 text-brand" /></div>
            <h1 className="font-heading text-4xl mt-4">Set a new password</h1>
            <p className="text-secondary mt-1">Choose a new password for your account.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="label-xs block mb-2">New password</label>
                <input data-testid="reset-password" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} className="w-full bg-surface-elevated border border-border rounded-lg px-4 py-3 focus:outline-none focus:border-brand" />
              </div>
              <div>
                <label className="label-xs block mb-2">Confirm password</label>
                <input data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full bg-surface-elevated border border-border rounded-lg px-4 py-3 focus:outline-none focus:border-brand" />
              </div>
              <button data-testid="reset-submit" disabled={loading} className="w-full py-3 bg-brand text-white font-bold uppercase tracking-wide rounded-lg hover:bg-brand-hover transition-all disabled:opacity-60">{loading ? "Updating..." : "Update Password"}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
